import React from 'react';
import { observer } from 'mobx-react-lite';
import { IconCheckmark, RadioButtonUnchecked } from '@insurancemenu/imenu-components-lib/dist/icons';
import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { useInitialSeedProductTemplatesStore } from 'store/pages/rfq/rfq-template/initial-seed-product-templates/pageStore';
import { normDateToAmericanDateTime } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import { InternalNameStyled, TableCellStyled, TableRowStyled } from './styles';
import MoreDropdown from '../MoreDropdown';

interface Props {
  productTemplateId: string;
  internalName: string;
  externalName: string;
  clientGroupId: string;
  jsonLink: string;
  creationDateTime: string;
  benefitSummaryPdfLink?: string;
  internalGroupId?: string;
  errorMessage?: string;
}

const TableRow: React.FC<Props> = observer(
  ({
    internalName,
    externalName,
    clientGroupId,
    jsonLink,
    creationDateTime,
    benefitSummaryPdfLink,
    internalGroupId,
    errorMessage,
  }) => {
    const { errorMessageModalDelegate } = useInitialSeedProductTemplatesStore();

    return (
      <TableRowStyled>
        <TableCellStyled width="8rem">
          <InternalNameStyled>{internalName}</InternalNameStyled>
        </TableCellStyled>
        <TableCellStyled width="5rem">{externalName}</TableCellStyled>
        <TableCellStyled width="5rem">{clientGroupId}</TableCellStyled>
        <TableCellStyled width="6rem">
          {benefitSummaryPdfLink ? <a href={benefitSummaryPdfLink}>Benefit Summary PDF</a> : null}
          {errorMessage ? (
            <Button
              type="text"
              color="custom"
              customColor={colors.red[600]}
              onClick={() => errorMessageModalDelegate.setMessageAndShowModal(errorMessage)}
            >
              Validation error
            </Button>
          ) : null}
        </TableCellStyled>

        <TableCellStyled width="6rem">{normDateToAmericanDateTime(creationDateTime)}</TableCellStyled>
        <TableCellStyled width="3rem">
          {internalGroupId ? (
            <IconCheckmark color={colors.green[600]} width="2rem" />
          ) : (
            <RadioButtonUnchecked color={colors.red[600]} width="2rem" />
          )}
        </TableCellStyled>
        <TableCellStyled width="4rem">
          <MoreDropdown clientGroupId={clientGroupId} jsonLink={jsonLink} />
        </TableCellStyled>
      </TableRowStyled>
    );
  },
);

export default TableRow;
